module.exports = __webpack_public_path__ + "35271d370769cda2fa24592538a74ace.png";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/sneaker.png
// module id = 211
// module chunks = 0